{
  "close": "Închideţi",
  "notifications": "{count, plural, one {# notificare} other {# notificări}}."
}
